export default function NotFound() {
  return (
    <div className='flex flex-col items-center justify-center pt-12'>
      <p className='text-center text-2xl font-bold'>Page Not Found</p>
    </div>
  );
}
